import { render, staticRenderFns } from "./createEditPg.vue?vue&type=template&id=8dbcfe34&scoped=true&"
import script from "./createEditPg.vue?vue&type=script&lang=js&"
export * from "./createEditPg.vue?vue&type=script&lang=js&"
import style0 from "./createEditPg.vue?vue&type=style&index=0&id=8dbcfe34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dbcfe34",
  null
  
)

export default component.exports